import { useState, useCallback } from 'react';
import { useTaskBundleDraft } from '../../../providers/TaskBundleProvider/TaskBundleProvider';

export const useTemplateDelete = () => {
  const { actions } = useTaskBundleDraft();
  const [taskToDelete, setTaskToDelete] = useState<string | null>(null);

  const confirmDelete = useCallback(() => {
    if (taskToDelete !== null) {
      actions.removeTemplate(taskToDelete);
      setTaskToDelete(null);
    }
  }, [taskToDelete, actions]);

  return {
    taskToDelete,
    setTaskToDelete,
    confirmDelete,
  };
};
